import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from 'sonner';
import Home from './pages/Home';
import Blog from './pages/Blog';
import About from './pages/aboutus';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/about" element={<About />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        theme="dark"
        position="top-right"
        toastOptions={{
          style: {
            background: '#0B0F14',
            border: '1px solid #3DF2E0',
            color: '#fff',
          },
        }}
      />
    </div>
  );
}

export default App;
